<p class="header-title">
    <ng-content select="[title]"></ng-content>
</p>